'use client'

import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import { useNow } from '@/hooks/use-now'

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/** "just now" / "5m ago" / "3h ago" / "2d ago" for an epoch-ms time, re-rendered every minute. */
export function useRelativeTime(): (at: number) => string {
  const t = useTranslations('common.relativeTime')
  const now = useNow(MINUTE)
  return useCallback(
    (at: number) => {
      const elapsed = Math.max(0, now - at)
      if (elapsed < MINUTE) return t('justNow')
      if (elapsed < HOUR) return t('minutesAgo', { count: Math.floor(elapsed / MINUTE) })
      if (elapsed < DAY) return t('hoursAgo', { count: Math.floor(elapsed / HOUR) })
      return t('daysAgo', { count: Math.floor(elapsed / DAY) })
    },
    [now, t]
  )
}
